export default {"src":"/_next/static/media/csv-svgrepo-com.3d4023fd.svg","height":303,"width":303,"blurWidth":0,"blurHeight":0};